module.exports = __webpack_public_path__ + "img/team-light.e8a1cc3f.png";